export default "__VITE_ASSET__BopAOn5H__"